import ReactDOMServer from 'react-dom/server';
import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import L from 'leaflet';
import {
  Marker, Popup, Tooltip,
} from 'react-leaflet';
import { RainIcon } from '../../../assets/svg/Icon';

// components
import StyledMarker from '../../../components/marker/Marker';
import RainColor from '../../rainfall/map/RinfallStatusColor';
import Contrast from '../../../utils/color/contrast';

// utils
import formatNumber from '../../../utils/number/Number';

// leaflet
import 'leaflet/dist/leaflet.css';
import '../../../components/map/Style.css';

import { styles } from '../style';

const useStyles = makeStyles(styles);

function styleMarker(color) {
  return ({
    type: 'rainfall',
    colorinfo: {
      icon: 'RainfallIcon',
      label: 'shapeCircle',
      color,
    },
  });
}

export default function RainMap(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas } = props;

  function RainStatus(value, color) {
    let backgroundcol = '#FFFFFF';
    if (typeof color !== 'undefined') {
      backgroundcol = color.color;
    } else {
      backgroundcol = RainColor(value, 'rainfall24h').color.statusColor;
    }
    const statusText = `
      <div
        style=background:${backgroundcol};text-align:center;width:60px;color:${Contrast(backgroundcol)};
      >
      ${formatNumber(value)} ${t('(มม.)')}
      </div>`;
    return typeof value === 'undefined' || value == null ? '-' : statusText;
  }

  const eachData = (data, i) => {
    if (data.tele_station_lat && data.tele_station_long) {
      // marker position
      const position = [parseFloat(data.tele_station_lat), parseFloat(data.tele_station_long)];

      const Rainfall24h = RainStatus(
        data.rain_24,
        data.color24,
      );
      const Rainfall1h = RainStatus(
        data.rain_1,
        data.color1,
      );
      // marker icons
      const styleClass = styleMarker(data.color.color);
      const icon = L.divIcon({
        className: 'styleClass',
        html: ReactDOMServer.renderToString(
          <StyledMarker category={styleClass.type} type={styleClass.colorinfo} />,
        ),
      });

      return (
        <Marker
          id={data.id}
          key={i}
          position={position}
          icon={icon}
        >
          <Popup autoPan={false}>
            <TableContainer>
              <Table size="small">
                <TableHead />
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                      <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                        {data.tele_station_name}
                      </Box>
                      <Box fontFamily="Kanit" fontSize="12px">
                        {data.tumbon_name !== '' ? `${t('ต.')} ${data.tumbon_name} ` : null}
                        {`${t('อ.')} ${data.amphoe_name} `}
                        {`${t('จ.')} ${data.province_name}`}
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                    <Box py={3} display="flex" justifyContent="center" alignItems="center">
                      <RainIcon style={{ fontSize: '4rem', fill: data.color.color }} />
                      <Box>
                        <Box fontFamily="Kanit" fontSize={12}>ฝนสะสม 24 ชม</Box>
                        <Box
                          className={`${classes.status}`}
                          dangerouslySetInnerHTML={{ __html: Rainfall24h }}
                        />
                        <Box fontFamily="Kanit" fontSize={12}>ฝนสะสม 1 ชม</Box>
                        <Box
                          className={`${classes.status}`}
                          dangerouslySetInnerHTML={{ __html: Rainfall1h }}
                        />
                      </Box>
                    </Box>
                    <Box mb={2} fontSize="16px" fontFamily="Kanit">
                      {t('ปริมาณฝน')}
                    </Box>
                  </TableCell>
                  <TableRow />
                  <TableRow>
                    <TableCell
                      className={classes.hiddenLine}
                      style={{ paddingTop: 10 }}
                      colSpan={2}
                    >
                      <Box color="text.disabled" fontSize="8px">{`${t('ข้อมูล')}: ${data.agency_name}`}</Box>
                      <Box color="text.disabled" fontSize="8px">
                        {t('ล่าสุด')}
                        {' : '}
                        {data.datetime}
                        {' '}
                        {t('น.')}
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Popup>
          <Hidden smDown>
            <Tooltip>
              <span>
                <strong>
                  {data.tele_station_name}
                </strong>
                <br />
                {`${t('ต.')} ${data.tumbon_name}`}
                <br />
                {`${t('อ.')} ${data.amphoe_name}`}
                <br />
                {`${t('จ.')} ${data.province_name}`}
              </span>
            </Tooltip>
          </Hidden>
        </Marker>
      );
    }
    return false;
  };

  return (
    <>
      {datas.map(eachData)}
    </>
  );
}

RainMap.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
};
